import { useEffect, useState, useRef } from 'react'
import { Outlet, Link } from "react-router-dom";
import './navigation.css'
import MenuIcon from '@mui/icons-material/Menu';

const ToggleMenuBtn = ({ showHeader, handleClick }) => <div className={`${showHeader ? 'navtoggle-visible' : 'navtoggle-hidden'} site-nav-toggle`}> <MenuIcon onClick={handleClick} id="mobile-nav-hamburger-btn" className={"mobile-nav-toggle mobile-only"} /> </div>

const Navigation = ({ showDropdown, setShowDropdown, dismissNav }) => {

    const [dropdownClass, setDropdownClass] = useState('hidden')

    function toggleDropdown() {
        console.log('called toggleDropdown')
        setShowDropdown(!showDropdown)
    }

    useEffect(() => {
        if (!showDropdown) {
            setDropdownClass('hidden')
        } else {
            setDropdownClass('visible')
        }
    }, [showDropdown])


    return (
        <nav className="navigation">
            <ul className="navigation">
                <li className="navigation small-nav" >
                    <Link className="navigation" onClick={dismissNav} to={`/`}>HOME</Link>
                </li>
                <li style={{ width: 250 }}>
                    <Link className="navigation" onClick={dismissNav} to={`message_of_peace`}>MESSAGE OF PEACE</Link>
                </li>
                <li style={{ width: 200 }} className="dropdown">
                    <button className="navigation dropdown" onClick={toggleDropdown}>TRIBAL INFO</button>
                    <ul class={`navigation dropdown ${dropdownClass}`}>
                        <li>
                            <Link className="navigation dropdown" onClick={dismissNav} to={`history`}>HISTORY</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={dismissNav} to={`documents`}>DOCUMENTS</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={dismissNav} to={`our_ancestors`}>OUR ANCESTORS</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={dismissNav} to={`contact`}>CONTACT</Link>
                        </li>
                    </ul>
                </li>
                <li className="navigation small-nav" >
                    <Link className="navigation" onClick={dismissNav} to={`news`}>NEWS</Link>
                </li>
                <li>
                    <a className="navigation" target="_blank" rel="noopener noreferrer" href="https://www.paypal.com/donate?token=RoZGzKoko7Us-Z_GEnpn1TFlJ6T2zaccBgZhDWr9ox_T_FgWhq9kNvwUbbnwdSm0H5MEL7NxYFJMJJYO">DONATE</a>
                </li>
            </ul>
        </nav>
    )
}

export { ToggleMenuBtn };

export default Navigation;